import {
  Directive,
  Inject,
  Input,
  OnDestroy,
  OnInit,
} from 'angular-ts-decorators';

import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { IHeroCustomizerSliderItem } from '../models/hero-customizer-slider-item';

import galleryTemplate from './open-hero-customizer-v3-image-gallery.html';

const GALLERY_VISIBILITY_THRESHOLD = 992;
const OVERFLOW_HIDDEN_CSS_CLASS = 'overflow-hidden';

interface IHeroCustomizerV3ImageGalleryScope extends ng.IScope {
  group?: IProductWithAttributes;
  sliderItems?: IHeroCustomizerSliderItem[];
  onClose?: () => void;
}

@Directive({
  selector: '[openHeroCustomizerV3ImageGallery]',
})
export class OpenHeroCustomizerV3ImageGalleryDirective implements OnInit, OnDestroy
{
  public static $inject: ReadonlyArray<string> = ['$element', '$window', '$compile', '$rootScope'];

  @Input() public items?: IHeroCustomizerSliderItem[];
  @Input() public group?: IProductWithAttributes;

  private openedGalleryElement?: JQLite;
  private openedGalleryScope?: IHeroCustomizerV3ImageGalleryScope;

  constructor(
    @Inject('$element') private readonly $element: JQLite,
    @Inject('$window') private readonly $window: ng.IWindowService,
    @Inject('$compile') private readonly $compile: ng.ICompileService,
    @Inject('$rootScope') private readonly $rootScope: ng.IRootScopeService,
  ) {}

  public ngOnInit() {
    this.$element.on('click', this.openGallery.bind(this));
    this.$window.addEventListener('resize', this.onWindowResize.bind(this));
  }

  public ngOnDestroy() {
    this.$element.off('click', this.openGallery.bind(this));
    this.$window.removeEventListener('resize', this.onWindowResize.bind(this));
  }

  private onWindowResize(): void {
    if (this.$window.innerWidth <= GALLERY_VISIBILITY_THRESHOLD) {
      this.closeGallery();
    }
  }

  private openGallery() {
    this.openedGalleryScope = this.$rootScope.$new(true);

    Object.assign(this.openedGalleryScope, {
      items: this.items || [],
      group: this.group,
      onClose: () => this.closeGallery(),
    });

    this.openedGalleryElement = this.$compile(galleryTemplate)(
      this.openedGalleryScope
    );
    document.body.classList.add(OVERFLOW_HIDDEN_CSS_CLASS);
    this.openedGalleryElement.appendTo(document.body);
  }

  private closeGallery() {
    document.body.classList.remove(OVERFLOW_HIDDEN_CSS_CLASS);

    this.openedGalleryScope?.$destroy();
    this.openedGalleryElement?.remove();
  }
}
